import { ApolloError } from "@apollo/client";

import { isApolloError } from "./isApolloError";
import { isPortexServerError } from "./isPortexServerError";

export function isPortexConnectionError(e: unknown): e is ApolloError {
  return isApolloError(e) && !isPortexServerError(e) && e.message === "Failed to fetch";
}
